import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import RawData from "../controllers/RawData/RawData";
import { getConfigVariable } from "../config/config";
import RawDataToolbar from "../components/RawDataToolbar/RawDataToolbar";

const queries = (args = {}) => {
    const resource = "raw_data";
    const queryArgs = {
        entity: args.entityRawData || "",
        projectId: args.projectId,
        fiscalYear: args.fiscalYear,
        modulePrefix: args.modulePrefix || "",
        importId: args.importId,
        filter: args.filter
            ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
            : undefined,
        sort: args.sort ? { type: "[SortInput!]", value: parseFilter(args.sort) } : undefined,
        page: parseInt(args.page, 10) || 0,
        pageSize: parseInt(args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE")),
    };

    const queryBody = `__typename, items, headerItems, metadata, filters(entity:$entity, modulePrefix:$modulePrefix){ prop, name, type, list, disableOperators, mandatory}`;

    return [
        {
            resource,
            args: { ...queryArgs },
            body: `${queryBody}, rawDataEdit`,
            downloadable: false,
            isDatagridReq: true,
        },
        {
            resource: `${resource}_export`,
            args: { ...queryArgs },
            body: queryBody,
            downloadable: true,
            downloadOnly: true,
            downloadFilePrefixName: resource,
        },
    ];
};

const rawData = (path, navigation, exact, navByImportId = false) => ({
    path,
    navigation,
    component: RawData,
    queries,
    exact,
    navByImportId,
    title: "label(param(entity))",
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).items",
                rawDataEdit: "query(0).rawDataEdit",
                header: "query(0).headerItems",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: "query(0).showCheckbox",
                total: "query(0).metadata.total",
                onRowEdit: true,
                cellHighlight: true,
                hideDeleteSeriesButton: true,
                basePath: path,
                toolbar: RawDataToolbar,
                toolbarProps: {
                    data: "query(0).items",
                },
                onRowClickCustom: () => {},
            },
        },
    ],
});

export default rawData;
